import { parsePhoneNumberFromString, isValidPhoneNumber } from 'libphonenumber-js'
import { useAuthStore } from '../store/authStore'

function normalizeNumber(input: string): string {
  if (input.startsWith('00')) {
    return '+' + input.slice(2)
  }
  return input
}

export default function usePhoneNumberValidation(phoneNumber: string) {
  const phoneNumberIsValid = () => {
    const authStore = useAuthStore()
    const normalized = normalizeNumber(phoneNumber)

    const isValid = isValidPhoneNumber(
      normalized,
      authStore.selectedOrganization?.attributes?.countryCode ?? 'ZA',
    )
    console.log(phoneNumber, isValid)
    return isValid
  }

  const formatPhoneNumber = () => {
    const authStore = useAuthStore()
    const normalized = normalizeNumber(phoneNumber)

    const number = parsePhoneNumberFromString(
      normalized,
      authStore.selectedOrganization?.attributes?.countryCode ?? 'ZA',
    )

    number.number = number.number.replace('+', '')
    console.log(number)

    return number
  }

  return { phoneNumberIsValid, formatPhoneNumber }
}
